// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".layout[data-v-24e36f90]{background:var(--color-lightest);color:var(--color-secondary)}.layout p[data-v-24e36f90]{color:inherit}[data-style=dark][data-v-24e36f90]{background:var(--color-secondary);color:var(--color-lightest)}[data-style=dark] p[data-v-24e36f90]{color:var(--color-gray-400)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
